import { useState } from 'react';
import type { AssessmentQuestion } from '@/lib/types';
import { inlineMarkdown } from '@/lib/markdown';

interface FreeTextProps {
  question: AssessmentQuestion;
  onAnswer: (answer: string) => void;
  disabled?: boolean;
  currentAnswer?: string;
}

export function FreeText({
  question,
  onAnswer,
  disabled = false,
  currentAnswer = '',
}: FreeTextProps) {
  const [text, setText] = useState(currentAnswer);

  const handleChange = (value: string) => {
    setText(value);
    onAnswer(value);
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-slate-900 dark:text-slate-100"
          dangerouslySetInnerHTML={{ __html: inlineMarkdown(question.question) }} />

      <textarea
        value={text}
        onChange={(e) => handleChange(e.target.value)}
        disabled={disabled}
        rows={6}
        className="w-full px-4 py-3 rounded-lg border-2 border-slate-200 dark:border-slate-700
                   bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100
                   placeholder-slate-400 dark:placeholder-slate-500
                   focus:border-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-400/20
                   disabled:opacity-50 disabled:cursor-not-allowed
                   resize-vertical"
        placeholder="Type your answer here..."
      />

      <p className="text-xs text-slate-500 dark:text-slate-400">
        {text.length} characters
      </p>
    </div>
  );
}
